import { ShieldCheck } from 'lucide-react';
import React, { ReactNode } from 'react';

import { UserWithHotel } from '../../../../../queries/usersQuery';

type IsHotelspotAdminRowProps = {
  data: UserWithHotel;
};

// `isHotelspotAdmin` z dokumentu `users/{uid}` (checkbox w formularzu użytkownika).
// Konta bez flagi zostawiamy puste — tak samo jak w kolumnie Staff.
export const IsHotelspotAdminRow = ({ data }: IsHotelspotAdminRowProps): ReactNode => (
  <div className="w-full flex justify-center items-center h-[40px]">
    {data.isHotelspotAdmin && (
      <ShieldCheck size={16} className="text-primary" aria-label="HotelSpot Admin" />
    )}
  </div>
);
